import { render, staticRenderFns } from "./Solicitante.vue?vue&type=template&id=5fa8f9e4&scoped=true"
import script from "./Solicitante.vue?vue&type=script&lang=js"
export * from "./Solicitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8f9e4",
  null
  
)

export default component.exports